import { z } from "zod";

const cents = z.string().regex(/^-?\d{1,28}$/u);
export const dailyCashSchema = z.object({
  date: z.iso.date(), company: z.string(), observedAt: z.iso.datetime(),
  accounts: z.array(z.object({
    kind: z.enum(["bank", "cash"]), code: z.string(), name: z.string(), currency: z.string().min(1),
    opening: cents, incoming: cents, outgoing: cents, closing: cents,
  })).max(1),
});
export type DailyCash = z.infer<typeof dailyCashSchema>;
export const dailyCashResponseSchema = dailyCashSchema.extend({ origin: z.enum(["saved", "mikro"]) });
export const cashMovementsSchema = z.object({
  date: z.iso.date(), observedAt: z.iso.datetime(), page: z.number().int().min(1).max(25), hasMore: z.boolean(),
  entries: z.array(z.object({ id: z.string(), date: z.iso.date(), document: z.string(),
    debit: cents, credit: cents, currency: z.string().min(1) })).max(40),
});
export type CashMovements = z.infer<typeof cashMovementsSchema>;

export function dailyCashTotals(accounts: DailyCash["accounts"], currency: string) {
  return accounts.filter((row) => row.currency === currency).reduce((sum, row) => ({
    opening: sum.opening + BigInt(row.opening), incoming: sum.incoming + BigInt(row.incoming),
    outgoing: sum.outgoing + BigInt(row.outgoing), closing: sum.closing + BigInt(row.closing),
    bank: sum.bank + (row.kind === "bank" ? BigInt(row.closing) : 0n),
    cash: sum.cash + (row.kind === "cash" ? BigInt(row.closing) : 0n),
  }), { opening: 0n, incoming: 0n, outgoing: 0n, closing: 0n, bank: 0n, cash: 0n });
}
